"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.authRouteConstants = void 0;
var loginAppPath = 'login';
var envIsLocal = process.env.REACT_APP_ENV === 'local';
var authRouteConstants = {
  Login: {
    name: 'Login',
    fullRoute: envIsLocal ? "http://localhost:3001/".concat(loginAppPath, "/login") : "/".concat(loginAppPath, "/login"),
    reactRouterRoute: 'login'
  },
  Logout: {
    name: 'Logout',
    fullRoute: envIsLocal ? "http://localhost:3001/".concat(loginAppPath, "/logout") : "/".concat(loginAppPath, "/logout"),
    reactRouterRoute: 'logout'
  },
  Callback: {
    name: 'Callback',
    fullRoute: envIsLocal ? "http://localhost:3001/".concat(loginAppPath, "/callback") : "/".concat(loginAppPath, "/callback"),
    reactRouterRoute: 'callback'
  },
  TenantContainer: {
    name: 'TenantContainer',
    fullRoute: envIsLocal ? "http://localhost:3001/".concat(loginAppPath, "/select-tenant") : "/".concat(loginAppPath, "/select-tenant"),
    reactRouterRoute: '/select-tenant'
  },
  SilentCallback: {
    name: 'SilentCallback',
    fullRoute: envIsLocal ? "http://localhost:3001/".concat(loginAppPath, "/silent-callback") : "/".concat(loginAppPath, "/silent-callback"),
    reactRouterRoute: 'silent-callback'
  }
};
exports.authRouteConstants = authRouteConstants;
var _default = authRouteConstants;
exports.default = _default;